/**
 * Notes Constants
 * Configuration and limits for notes management
 */

// Content limits
export const MAX_CONTENT_LENGTH = 10 * 1024 // 10KB
export const MAX_NOTES_PER_USER = 1000
